<template>
<div class="chapter">
<div class="inner_page">
<div class="preface1" id="fm3">
<p class="indent"><a id="page14"></a><a id="page15"></a>Up to now they used to shiver every time they heard mention of the Romans’ skill in warfare, but now they are victorious, and we die, nobly, as befits brave men, but perishing all the same.</p>
<div class="block11">
<p class="nonindent">—Libanius, 378<br/><br/></p>
</div>
<p class="indent">Let the dead be carried gently;</p>
<p class="indent">let them wonder, who are living,</p>
<p class="indent">what choice shall be tomorrow.</p>
<div class="block11">
<p class="nonindent">—Graydon Saunders, “The Pebble,” 1998</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312876531_epub_fm3_r1.vue?5e1a4935